import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Pago.types';
export * from './Buscador';
import { IPago } from './Pago.lib';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';

export class Pago extends IPago
{

    public static async create( id: number ): Promise<Pago>
    {
        let o = new Pago();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/pagos';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Pago>; Error?: boolean; }>
    {

        let a: Array<Pago> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/pagos` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Pago( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            console.log( js );
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }


    public static async SubirComprobante( file: File ): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 100000;

        req.path = `/pagos/comprobantes/upload`;
        req.useformData = true;
        req.formData.append( 'file', file );

        if ( await req.post() )
        {
            return req.data.id;
        }
    }

    public static async CrearPago( opt: any): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 100000;

        req.path = `/pagos`;
        req.body = opt;

        if ( await req.post() )
        {
            return req.data.id;
        }
    }

    public async Modificar( opt: any ): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 100000;

        req.path = `/pagos/${this.Id}`;
        req.body = opt;

        if ( await req.put() )
        {
            return req.data.id;
        }
    }

    public static async DescargarMercadoPago( cuenta: string, id: string )
    {
        let request = new apiRequest( `/mercadolibre/pagos/e/${cuenta}/${id}` );

        if ( await request.post() )
        {
            return true;
        }
    }

    public static async DescargarTodoMercadoPago( cuenta: string ): Promise<{ Total: number, Proceso: string; }>
    {
        let request = new apiRequest( `/mercadolibre/pagos/e/${cuenta}` );
        request.timeOut = 100000;
        if ( await request.post() )
        {
            return { Total: request.data.total, Proceso: request.data.process };
        }
    }

    public static async URLListado( filtros: any, ids?: string[] ): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 10000000;
        req.path = '/pagos/listado';
        if ( ids )
        {
            req.body.ids = ids.join( ',' );
        } else
        {
            req.body.filtros = filtros;
        }

        req.params.response_type = 'pdf';
        if ( await req.post() )
        {
            return req.data.u;
        }
    }

    public async AgregarAlPedido( pedido: Pedido ): Promise<boolean>
    {
        let e = await pedido.AgregarPagos( [this.Id.toString()] );
        return e;
    }

}